<script setup>
defineProps({
  noGutters: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <div :class="['row', { 'no-gutters': noGutters }]">
    <slot></slot>
  </div>
</template>
